// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMAvatar.tsx — PropelMapper avatar (colored initials or image).
// Round, fixed-size, colored background (default --pm-accent). Wrap several in
// a <span class="pmav-stack"> for an overlapping stack.

const PMAV_CSS = `
.pmav{box-sizing:border-box;display:inline-grid;place-items:center;border-radius:50%;color:#fff;font-weight:700;font-family:var(--pm-font-sans);line-height:1;flex:0 0 auto;overflow:hidden}
.pmav img{width:100%;height:100%;object-fit:cover;display:block}
.pmav-stack{display:inline-flex}
.pmav-stack .pmav{border:2px solid var(--pm-surface)}
.pmav-stack .pmav + .pmav{margin-left:-9px}
`;
function pmavEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmav-css")) return;
  const s = document.createElement("style"); s.id = "pmav-css"; s.textContent = PMAV_CSS;
  document.head.appendChild(s);
}
function pmavInitials(name) {
  if (!name) return "";
  const parts = String(name).trim().split(/\s+/);
  return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
}
export function PMAvatar({ name, initials, src, size = 32, color = "var(--pm-accent)", className = "", style = {}, ...rest }) {
  pmavEnsureCSS();
  const txt = initials != null ? initials : pmavInitials(name);
  const box = { width: size, height: size, fontSize: Math.round(size * 0.42), background: src ? "var(--pm-surface-variant)" : color, ...style };
  return (
    <span className={"pmav" + (className ? " " + className : "")} style={box} title={name} {...rest}>
      {src ? <img src={src} alt={name || ""} /> : txt}
    </span>
  );
}
